
import { FunnelsServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      funnelId: "",
      deletedPages: [],
      restoreInProgress: false,
      loadingPages: false
    };
  },
  methods: {
    async fetchDeletedPagesForFunnels() {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.loadingPages = true;
        const { data } = await FunnelsServices.getDeletedFunnelPages({
          locationId: this.locationId,
          funnelId: this.funnelId
        });
        this.deletedPages = data.pages;
        this.loadingPages = false;
      } catch (error) {
        console.log(error);
        this.loadingPages = false;
      }
    },
    async restorePage(page: any) {
      try {
        if (!this.locationId || !this.funnelId) {
          throw new Error("Missing is required fields");
        }
        this.restoreInProgress = true;

        await FunnelsServices.restorePage({
          locationId: this.locationId,
          pageId: page.id
        });

        this.fetchDeletedPagesForFunnels();
        this.restoreInProgress = false;
      } catch (error) {
        console.error(error);
        this.restoreInProgress = false;
      }
    }
  }
});
